'use client';

import { Suspense } from 'react';
import CookiePolicy from '../components/CookiePolicy';
import CookiePolicySkeleton from '../components/CookiePolicySkeleton';
import type { CookiePolicyData } from '@/types/cookie-policy';

interface CookiePolicyClientProps {
  locale: string;
  data: CookiePolicyData | null;
}

export default function CookiePolicyClient({ locale, data }: CookiePolicyClientProps) {
  return (
    <Suspense fallback={<CookiePolicySkeleton />}>
      <CookiePolicy locale={locale} data={data} />
    </Suspense>
  );
}
